import { UserContact } from "../molecule/userContact";

export function ProfileComp({user,isLoading,goProfile,updateUser,allowProfileEditing}){
    return(
        <div onClick={goProfile} className="horizontal" style={{width:"unset", alignItems:"baseline"}}>
            <UserContact isLoading={isLoading} allowEditing={allowProfileEditing} updateUser={(newUser) => updateUser(newUser)} user={user}/>

            {/* 
            <img className="avatar" src={''} alt="avatar"/>
            <UserData title={"Email"} content={user.email}/>
            <UserData title={"Telefoon"} content={user.phone}/>
            <UserData title={"Bedrijf"} content={user.business}/>
            <InformationPill title={"E-mail"} content={user.email} icon2={"mail"}/>
            <InformationPill title={"Tel. nr"} content={user.phone} icon2={"phone"}/>  */}
        </div>
    )
 
}

